var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content pb-0" },
    [
      _c("Titlebar", { attrs: { incrustation: "fa-bullhorn" } }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("remoteMonitoring.list.title")))]),
      ]),
      _vm._v(" "),
      _c(
        "UiCard",
        [
          _vm.canBrowse
            ? _c("SuperTable", {
                ref: "tableProcedures",
                attrs: {
                  tableColumns: _vm.tableColumns,
                  tableData:
                    _vm.viewState === "SUCCESS" ? _vm.rmListData.data : [],
                  loading:
                    _vm.viewState === "INITIAL" || _vm.viewState === "LOADING",
                },
                on: {
                  sort: _vm.handleSort,
                  filter: _vm.handleFilter,
                  delete: _vm.handleDelete,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.canBrowse
            ? _c("p", [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("module.forbidden")) + "\n    "
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("Toolbar", { staticClass: "d-flex align-items-center" }, [
        _c(
          "div",
          { staticClass: "flex-grow-1" },
          [
            _c(
              "UiButton2",
              {
                directives: [
                  {
                    name: "can",
                    rawName: "v-can",
                    value: "beepiz-log-remotemonitoring",
                    expression: "'beepiz-log-remotemonitoring'",
                  },
                ],
                staticClass: "ml-auto btn-lg",
                nativeOn: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleLogs()
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-list-ul mr-2" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("remoteMonitoring.btns.logs")) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-grow-1" },
          [
            _c("TablePagination", {
              ref: "monitorpagination",
              on: { change: _vm.handlePagination },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-grow-1 text-right" },
          [
            _c(
              "UiButton2",
              {
                directives: [
                  {
                    name: "can",
                    rawName: "v-can",
                    value: "beepiz-add-remotemonitoring",
                    expression: "'beepiz-add-remotemonitoring'",
                  },
                ],
                staticClass: "btn-brand btn-lg ml-auto",
                nativeOn: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleNew()
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-plus mr-2" }),
                _vm._v(" " + _vm._s(_vm.$t("global.add")) + "\n      "),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }